<script setup>
/*
    Form widget - Input form

    Components:
        primary: <vu-form>

    Widget Properties:
        form
        text 
        validate

    CSS Properties:
        font-size | Font size of the form text.
        font-weight | Font weight of the form text. Defaults to bold.
        button.color | Color of the form text
        button.background | Background color of the form button. Defaults to accent
        button.--w-variant | Set to elevated, flat, tonal, outlined, text or plain
        button.--w-block | Set to true to make the button full width
        button.--w-density | Set to compact, default or comfortable
        button.--w-ripple | Set to enable the ripple effect
 */
import {onBeforeMount, reactive, ref} from 'vue'
import {State} from '@/paks/vu-app'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'

const emit = defineEmits(['submit'])

const props = defineProps({
    dashboard: Object,
    saving: Boolean,
    widget: Object,
})

const page = reactive({
    args: {},
    data: {},
})

defineExpose({page, update})

const primary = ref(null)
const button = ref(null)

const DefaultStyles = {
    primary: {
        'font-size': 'max(10px, min(min(9cqw, 20cqh), 144px))',
        'font-weight': 'bold',
    },
    button: {
        'background': 'rgb(var(--v-theme-primary))',
        'color': 'rgb(var(--v-theme-on-primary))',
    },
}

onBeforeMount(() => {
    let widget = props.widget
    widget.value = {}
    if (widget.form) {
        State.cache.setForm(widget.form, widget)
    }
})

function update() {
    Object.assign(page, getWidgetProps(props.widget, {primary, button}, {styles: DefaultStyles}))
}

async function preSave() {
    let widget = props.widget
    /*
        Validate input fields
     */
    let error = false
    for (let w of props.dashboard.widgets) {
        if (w.form == widget.form && w.input != 'form') {
            if (!new RegExp(w.validate).exec(w.value)) {
                w.errors = ['Bad format for field']
                error = true
            } else {
                w.errors = []
            }
        }
    }
    return !error
}

async function save() {
    emit('submit', props.widget)
}

async function saveError() {}

async function postSave() {}

</script>

<template>
    <vu-form
        ref="primary"
        :options="{progress: false}"
        :save="save"
        :error="saveError"
        :pre-save="preSave"
        :post-save="postSave"
        class="form-widget">
        <v-btn
            ref="button"
            color="primary"
            type="submit"
            :loading="page.saving"
            :size="page.size"
            v-bind="page.args">
            {{ page.data?.primary || 'Save' }}
        </v-btn>
    </vu-form>
</template>

<style lang="scss">
.form-widget {
    container-type: size;
    position: relative;
    height: 100cqh !important;
    width: 100cqw !important;
    text-align: center;
    padding: 0;
    top: 50cqh;
    transform: translateY(-50%);
    .v-btn {
        height: 100%;
        width: 100%;
        font-size: inherit;
    }
}
</style>
